export const isValueNullish = <T>(val: T): val is Extract<T, null | undefined> =>
	val === undefined || val === null;

export const idsMatch = (left: unknown, right: unknown): boolean =>
	!isValueNullish(left) && !isValueNullish(right) && `${left}` === `${right}`;

interface FieldValue {
	DataId?: unknown;
	EntityId?: unknown;
	Number?: unknown;
	Time?: unknown;
}

interface FieldConfig {
	Type?: {
		Code?: string;
	};
}

export const isFieldValueValid = (fieldValue?: FieldValue, fieldConfig?: FieldConfig): boolean => {
	switch(fieldConfig?.Type?.Code) {
		case "NUMBER":
			return !isValueNullish(fieldValue?.DataId ?? fieldValue?.EntityId) && !isValueNullish(fieldValue?.Number);
		case "TIME":
			return !isValueNullish(fieldValue?.Time);

		default:
			return fieldValue !== undefined;
	}
};
